import React from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  Box,
} from "@mui/material";
import { ArrowUp, ArrowDown } from "lucide-react";

const columns = [
  { key: "title", label: "Title", searchable: true, sortable: true, width: "50%" },
  { key: "status", label: "Status", searchable: true, sortable: true, width: "auto" },
  { key: "category", label: "Category", searchable: true, sortable: true, width: "auto" },
  { key: "priority", label: "Priority", searchable: true, sortable: true, width: "auto" },
  { key: "upvotes", label: "Upvotes", searchable: false, sortable: true, width: "auto", align: "center" },
  { key: "comments", label: "Comments", searchable: false, sortable: true, width: "auto", align: "center" },
  { key: "created_by", label: "Submitted By", searchable: true, sortable: true, width: "auto", align: "left" },
  { key: "submitted_date", label: "Submitted Date", searchable: true, sortable: true, width: "auto", align: "left" },
  { key: "assigned_to", label: "Assigned To", searchable: true, sortable: true, width: "1%", align: "center" },
  { key: "copy_link", label: "Copy Link", searchable: false, sortable: false, width: "auto", align: "center" },

];

const FeatureRequestTableHead = ({
  sortBy,
  sortOrder,
  columnSearch,
  onSortChange,
  onSearchChange,
}) => {
  // Handle sort click
  const handleSort = (columnKey) => {
    if (!columns.find((col) => col.key === columnKey)?.sortable) return;

    let newSortOrder = "asc";
    if (sortBy === columnKey) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    }
    onSortChange(columnKey, newSortOrder);
  };

  // Render sort icon
  const renderSortIcon = (columnKey) => {
    const col = columns.find((c) => c.key === columnKey);
    if (!col?.sortable) return null;

    if (sortBy === columnKey) {
      return sortOrder === "asc" ? (
        <ArrowUp size={12} />
      ) : (
        <ArrowDown size={12} />
      );
    }
    return <ArrowUp size={12} style={{ opacity: 0.3 }} />;
  };

  // Get placeholder for search input
  const getPlaceholder = (columnKey) => {
    if (columnKey === "submitted_date") {
      return "YYYY-MM-DD";
    }
    return "Search";
  };

  return (
    <TableHead sx={{ position: "sticky", top: 0, zIndex: 2, backgroundColor: "#F0FDFA", "& .MuiTableCell-head": { backgroundColor: "#F0FDFA" } }}>
      {/* Header Row with Sort */}
      <TableRow sx={{ backgroundColor: "#F0FDFAv" }}>
        {columns.map((col) => (
          <TableCell
            key={col.key}
            onClick={() => col.sortable && handleSort(col.key)}
            align={col.align || "left"}
            sx={{
              fontSize: "12px",
              fontWeight: 400,
              color: "#404040",
              padding: "10px 16px 6px 16px",
              whiteSpace: "nowrap",
              cursor: col.sortable ? "pointer" : "default",
              userSelect: "none",
              width: col.width,
              borderBottom: "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                justifyContent: col.align === "center" ? "center" : "flex-start",
              }}
            >
              {col.label}
              {renderSortIcon(col.key)}
            </Box>
          </TableCell>
        ))}
      </TableRow>

      {/* Search Row */}
      <TableRow sx={{ backgroundColor: "#F0FDFA" }}>
        {columns.map((col) => (
          <TableCell
            key={`search-${col.key}`}
            sx={{
              padding: "0 16px 10px 16px",
              fontWeight: 400,
              borderBottom: "none",
            }}
          >
            {col.searchable ? (
              <input
                style={{
                  width: "100%",
                  fontSize: "12px",
                  padding: "8px 10px",
                  backgroundColor: "white",
                  borderRadius: "4px",
                  border: "none",
                  outline: "none",
                  fontWeight: 400,
                }}
                placeholder={getPlaceholder(col.key)}
                value={columnSearch[col.key] || ""}
                onChange={(e) => onSearchChange(col.key, e.target.value)}
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <Box sx={{ height: "32px" }} />
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default FeatureRequestTableHead;

